/**
 * Identidade do produto Nolens Guides. Todos os produtos Nolens partilham o símbolo (N com
 * quatro nós, o último em teal), a tipografia (Inter) e as superfícies; só a cor do produto
 * muda (Business azul, Personal roxo, Physio verde, Athletics vermelho, Guides laranja).
 * Para mudar: estes valores, os de `--brand-*` e `--accent` em packages/ui/src/tokens.css,
 * e correr `pnpm brand:icons`.
 */
export const PRODUCT = {
  name: 'Guides',
  fullName: 'Nolens Guides',
  /** Fundo do símbolo (tile). 8,1:1 com o traço claro. */
  tile: '#8A2B06',
  /** Cor do descritor e de ação: 5,2:1 com texto branco; 4,8:1 sobre a superfície clara. */
  accent: '#C2410C',
  /** Descritor em modo escuro: ≥ 7,7:1 sobre as superfícies escuras. */
  accentOnDark: '#FB923C',
  /** Nó teal comum a todos os produtos Nolens. */
  bright: '#2FB39D',
} as const;
